import React from 'react'
import Column from '../../../generic/Column'
import Columns from '../../../generic/Columns'
import { BoxCenter } from '../../../generic/Box'
import Title from '../../../generic/Title'
import Loader from '../../../generic/Loader'
import TileShowcase from '../../TileShowcase'
import Calendar from 'react-calendar'
import { inject, observer } from 'mobx-react'

const NFEFilter = inject('nfeStore')(observer(props => {
  const { nfeStore } = props
  const { date, isFetching } = nfeStore.state
  const minDate = new Date()
  minDate.setDate(minDate.getDate() - 60)
  const maxDate = new Date()
  return (
    <Columns>
      <Column>
        <BoxCenter>
          <Title>Data</Title>
          <Calendar minDate={minDate} maxDate={maxDate} value={date} onChange={value => nfeStore.setDate(value)} />
        </BoxCenter>
      </Column>
      <Column>
        <BoxCenter>
          <Title>Notas enviadas</Title>
          <Loader isLoading={isFetching}>
            <TileShowcase data={nfeStore.amountSent} />
          </Loader>
        </BoxCenter>
      </Column>
    </Columns>
  )
}))

export default NFEFilter



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfe/NFEFilter.js